export default __webpack_public_path__ + "static/form-visible-label-do-74b02754060165a76c1cedd5d0706eb2e2f11fd4745b15dbb64e5b372368a958.png";